@if (isLoggedIn | async) {
<div>
	@if ((orderOnBehalfService.customerAsObservable() | async)) {
	<on-behalf-of-bar></on-behalf-of-bar>
	}
	<div class="cst-header">
		<div class="cst-left" [ngClass]="animationImageState" (transitionend)="onImageAnimationDone()">
			<div class="cst-logo" (click)="goToHome()">
				<img src="/assets/images/logo.svg" />
			</div>
		</div>
		<div class="cst-center">
			<div class="cst-search">
				<input [ngClass]="animationSearchState" (transitionend)="onSearchAnimationDone($event)" #search placeholder="search" (input)="applyFilter($event)" (keyup)="handleKeyUp($event)" (click)="search.select()" />
				<i class="fa-light fa-search fa-xl search-icon" (click)="toggleSearch(true)"></i>
			</div>
			<i [ngClass]="animationCloseSearchState" class="fa-light fa-times fa-xl close-search-icon" (click)="toggleSearch()"></i>
			<div class="cst-filter cst-icon" (click)="goToFilter()">
				<i class="fa-light fa-sliders fa-xl"></i>
			</div>
		</div>
		<div class="cst-right">
			<div class="cst-client-display">
				<cstmsr-extended-toggle [value1]="'client'" [value2]="'display'" [selected]="this.enduserDisplayService.IsClient() ? 1 : 2" [mini]="toggleMini" (valueChanged)="clientDisplayValueChanged($event)"></cstmsr-extended-toggle>
			</div>
			@if (consultantOrChain) {
			<div class="cst-customer-selector">
				<button class="cst-customer-selector-button" [ngClass]="{'disabled': addToBagInProgress}" (click)="goToCustomerSelector()">
					{{ (userCanOrderOnBehalf ? 'HOME.NEWORDERFORCUSTOMER' : 'HOME.NEWORDERFORSHOP') | translate }}
				</button>
			</div>
			}
			<div class="icons">
				<div class="cst-favorites cst-icon" (click)="goToFavorites()">
					<i class="fa-light fa-heart fa-xl"></i>
				</div>
				<div class="cst-bag cst-icon" [ngClass]="{'disabled': addToBagInProgress}" (click)="hasBagErrors ? toggleShowBagErrorItems($event) : goToBag()">
					<div [@pulse]="animateIcon('bag')" class="notifications">
						@if (!hasBagErrors) {
						<icon-bag [showSpinner]="addToBagInProgress"></icon-bag>
						}
						@if (bagCount && !hasBagErrors && !addToBagInProgress) {
						<span class="badge" [@newOrderTransition]="bagCount"><span>{{bagCountSpecified}}</span></span>
						}
						@if (hasBagErrors) {
						<icon-bag-error [showErrorItems]="showBagErrorItems"></icon-bag-error>
						}
					</div>
				</div>
				<div class="cst-menu cst-icon" (click)="openMenu()">
					@if (isMenuOpen) {
					<i class="fa-light fa-times fa-xl"></i>
					}
					@else {
					<i class="fa-light fa-bars fa-xl"></i>
					}
					@if (showNotificationBullet) {
					<span class="menu-bullet"></span>
					}
				</div>
			</div>
		</div>
	</div>
	@if (showFilterBar) {
	<app-model-filter></app-model-filter>
	}
</div>
}

@if (isLoggedIn | async) {
<options-dropdown [showTermsNotification]="showNotificationBullet" [doShowTerms]="showTermsInDropdownMenu" (stateChanged)="handleMenuChange($event)"></options-dropdown>
}